// extracted by mini-css-extract-plugin
export var cards = "e_bf_cS";
export var container = "e_bf_j";
export var imageContainer = "e_bf_bD";
export var imgWrapper = "e_bf_cV";
export var library = "e_bf_cR";
export var moduleContainer = "e_bf_cQ";
export var quiz = "e_bf_cT";
export var reversed = "e_bf_cP";
export var textContainer = "e_bf_by";